import { useMutation } from '@redwoodjs/web';

import { showErrorToast, showSuccessToast } from 'src/components/Toasts/toast';
import { CREATE_NOTE } from 'src/graphql/mutations/notes.mutation';

type CreateNoteInput = {
    merchantId?: number;
    partnerId?: number;
    partnerOfPartnerId?: number;
    applicationId?: number;
    onRefetch?: () => Promise<unknown>;
};

const useCreateNote = ({
    merchantId,
    partnerId,
    applicationId,
    partnerOfPartnerId,
    onRefetch,
}: CreateNoteInput) => {
    const [createNote] = useMutation(CREATE_NOTE, {
        onError: () => {
            showErrorToast('We were unable to create the note. Please try again.');
        },
        onCompleted: () => {
            showSuccessToast('Note created!');
            if (onRefetch) {
                onRefetch();
            }
        },
    });

    return {
        onCreateNote: ({ description, subject }: { description: string; subject: string }) => {
            return createNote({
                variables: {
                    input: {
                        body: description,
                        subject,
                        merchantId,
                        partnerId,
                        applicationId,
                        partnerOfPartnerId,
                    },
                },
            });
        },
    };
};

export default useCreateNote;
